import { useMemo } from 'react';
import { getUserInfo } from '../utils/user';
import { useNewScreenQuery } from '@intigral/domain/lib/presentation/hooks/useNewScreenQuery';
import { useHeaderMenuQuery } from '../hooks/useHeaderMenuQuery';
// import { useSelector } from 'react-redux';
// import { IStore } from '../interfaces/StoreTypes';
import { filterComponents } from '../utils/filterComponents';
import NewUpcoming from '../components/ui/NewUpcoming';
import useLanguage from '../hooks/useLanguage';
import { getActiveCarouselsFromLayout } from '../utils/getActiveCarouselsFromLayout';
import { isGuestUser } from '../config/guestMode';
// import { RenderedComponent } from './ScreenCarousel';
// import { useWindowVirtualizer } from '@tanstack/react-virtual';

export default function VerticalScreen({ screenName, screenKey, pathValue }) {
    const userInfo = getUserInfo();

    const { isLoading, isError, data, error } = useNewScreenQuery(
        screenName,
        screenKey,
        'deviceType=pc',
        userInfo.apiKey
    );

    const { data: headerData } = useHeaderMenuQuery();

    const language = useLanguage();

    const isGuest = isGuestUser(userInfo);
    const components = useMemo(() => getActiveCarouselsFromLayout(data, isGuest), [data, isGuest]);
    const filteredComponents = filterComponents(components);
    const layoutType =
        headerData?.find((item) => item.screen?.toLowerCase() === pathValue.toLowerCase())?.layoutType ?? 'HORIZONTAL';

    return (
        <NewUpcoming
            components={filteredComponents}
            isLoading={isLoading}
            isError={isError}
            layoutType={layoutType}
            language={language}
        />
    );
}
